import NumberInput from '@wandb/weave/common/components/elements/NumberInput';
import React, {useCallback} from 'react';

import {SettingLabel} from '../components/SettingLabel';
import {SemanticLegendSettings} from '../types';
import {
  MAX_NUMBER_OF_BUCKETS,
  MIN_NUMBER_OF_BUCKETS,
} from './utils/recalculateSemanticLegendBuckets';

export type SemanticLegendNumBucketsProps = {
  numberOfBuckets: number;
  updateSetting: (settings: Partial<SemanticLegendSettings>) => void;
};

export const SemanticLegendNumBuckets = ({
  updateSetting,
  numberOfBuckets,
}: SemanticLegendNumBucketsProps) => {
  const updateSettingValue = useCallback(
    (newVal?: number) => {
      if (newVal == null) {
        newVal = 4;
      }
      updateSetting({
        numberOfBuckets: newVal,
        shouldRecalculateBuckets: true, // we want to recalculate the buckets bounds when the number of buckets changes
      });
    },
    [updateSetting]
  );
  return (
    <div
      className={'flex w-full items-center gap-20 py-16'}
      data-test="num-buckets-setting">
      <SettingLabel text="Number of buckets" className="min-w-fit" />
      <NumberInput
        placeholder="Number of buckets"
        min={MIN_NUMBER_OF_BUCKETS}
        max={MAX_NUMBER_OF_BUCKETS}
        stepper={true}
        value={numberOfBuckets}
        onChange={updateSettingValue}
        useStepperPlusMinus
      />
    </div>
  );
};
